/*window.BOLD.common.Shopify.products = window.BOLD.common.Shopify.products || {};
window.BOLD.common.Shopify.variants = window.BOLD.common.Shopify.variants || {};
window.BOLD.common.Shopify.handles = window.BOLD.common.Shopify.handles || {};


window.BOLD.common.Shopify.handle = "5-meals-week"
window.BOLD.common.Shopify.saveProduct("6-meals-week", 1421535117355);
window.BOLD.common.Shopify.saveVariant(39299947102342, { product_id: 1421535117355, product_handle: "6-meals-week", price: 5940, group_id: '170115', csp_metafield: {}});
window.BOLD.common.Shopify.saveVariant(39299947135110, { product_id: 1421535117355, product_handle: "6-meals-week", price: 6540, group_id: '170115', csp_metafield: {}});
window.BOLD.common.Shopify.saveVariant(39299947167878, { product_id: 1421535117355, product_handle: "6-meals-week", price: 7740, group_id: '170115', csp_metafield: {}});


window.BOLD.apps_installed = {"Product Options":2,"Recurring Orders":1} || {};
window.BOLD.common.Shopify.metafields = window.BOLD.common.Shopify.metafields || {};
window.BOLD.common.Shopify.metafields["bold_rp"] = {"recurring_type":1};
window.BOLD.common.Shopify.metafields["bold_csp_defaults"] = {};
window.BOLD.common.cacheParams = window.BOLD.common.cacheParams || {};
window.BOLD.common.cacheParams.recurring_orders = 1618933625;*/


var fmv2 = {};


fmv2.stickyHeader = (function() {
	var header = $('.fmv2-header'),
        topSummary = $('.fmv2-cart-summary.fmv2-top');
  
  	function stickHeader() {
      	if ($(window).scrollTop() >= 155)  {
        	header.addClass('sticky');
        	topSummary.addClass('fmv2-top-sticky');
      	}
      	else if (header.hasClass('sticky')) {
			header.removeClass('sticky');
          	topSummary.removeClass('fmv2-top-sticky');
        }
  	}
  
  	function init() {
      	stickHeader();
    	$(window).scroll(stickHeader);
    }
  
  	return {
      init: init
  	}
})();

//$('#product_form_1421535117355').submit(function(e) { e.preventDefault(); })


fmv2.subscribtion = (function() {
  	var total = 0,
        delivery = 0,
        discount = 0.05,
        weeks = 1,
    	quantity = 0,
    	initialPrice = 0,
        deliveryPrice = 0,
        point = '',
        prodQuantity = $('#quantity'),
    	subCart = $('.fmv2-subscription-summary'),
        subCartPrice= subCart.find('.fmv2-subcart-price'),
        subCartPriceMealPrice = subCart.find('.fmv2-subcart-meal-price'),	
        subCartDelivery = subCart.find('.fmv2-subcart-delivery'),
        subCartTotal = subCart.find('.fmv2-subcart-total'),
        subMeals = $('input.fmv2-subdata-meals'),
        subSize = $('input.fmv2-subdata-size'),
        subPickup = $('select#fmv2-subdata-pickup-points'),
        subDeliveryLabelWrap = $('.fmv2-delivery-variant'),
        subPickupLabel = subDeliveryLabelWrap.find('div:first-child'),
        subDeliveryLabel = subDeliveryLabelWrap.find('div:last-child'),
        subDiscountInvoice = $('#fmv2-discount-invoice'),
        subDeliveryPriceInvoice = $('#fmv2-delivery-price-invoice'),
        subDay = $('input.fmv2-subdata-day'),
        subFrequency = $('input.fmv2-subdata-frequency'),
        subNextBtn = $('.fmv2-subscription-next'),
    	
        subscribeBtn = $('.fmv2-subscribe-btn'),
        productsSlider = $('.fmv2-subscription-slider');
  
  	function updateBoldProduct(id, handle) {
      console.log(id, handle);
      	window.BOLD.common.Shopify.products = {};
		window.BOLD.common.Shopify.variants = {};
		window.BOLD.common.Shopify.handles = {};  
      
      	window.BOLD.common.Shopify.handle = handle
      	window.BOLD.common.Shopify.saveProduct(handle, {id: id*1});
    }
  	
  	function updateBoldVariants(productId, handle, variantId, variantPice) {
      console.log(productId, handle, variantId, variantPice);
		window.BOLD.common.Shopify.saveVariant(variantId, { product_id: productId, product_handle: handle, price: variantPice, group_id: '170115', csp_metafield: {}});
    }
  	
  
  	function selectProduct() {
      	var products = productsSlider.find('.slick-track'),
            activeProduct = products.find('.active-middle'),
            productUrl = '';
      	
        if (!activeProduct.length)
        	activeProduct = products.find('.slick-active');
        
        productUrl = activeProduct.find('a:first').attr('href');
        
       	if (productUrl)
          window.location.href = productUrl;
  	}
  
  	function formatPrice(val) {
      	var val = Math.ceil(val);
     
        val = (val / 100).toFixed(2)
      
    	return val.replace('.', '.') + ' &euro;'
  	}
  	
  	
  	function updateCart() {
       	var mealTotal = 0,
            disDelivery = 0,
        	disTotal = 0,
        	mealPrice = 0;
      
      	total = initialPrice;
      
      	if (discount)
          total = total - (total * discount);
      
        mealPrice = total / quantity; 
        
        total = total * weeks;
      
      	if (total >= 8000) {
        	delivery = 0;
          	subDeliveryLabel.find('span:last-child').html('Free');
      	}
      	else if (point.indexOf('home/office ') > -1) {
          	delivery = deliveryPrice;
      		subDeliveryLabel.find('span:last-child').html(formatPrice(deliveryPrice));
        }
      
      	mealTotal = total;
      	total = total + delivery;
      	disTotal = total;
      	disDelivery = delivery;
      
        // subCartPrice.html(formatPrice(mealTotal));
        subCartPriceMealPrice.html(formatPrice(mealPrice));
      	// subCartDelivery.html(formatPrice(disDelivery));
      	subCartTotal.html(formatPrice(disTotal));
      
      	
      	subDeliveryPriceInvoice.val(subDeliveryLabelWrap.find('div:visible').find('span:last-child').text())
      
      	enableSubscribeBtn();
  	}
  
  	function countMeals() {
    	var selectedMeals = $(this),
            productId = selectedMeals.val(),
            productHandle =  selectedMeals.attr('data-product-handle'),
      		selectedSize = subSize.filter(':checked'),
          	unselectedSize = selectedSize.closest('ul').find('input:not(:checked)').first();
      	
      	updateBoldProduct(productId, productHandle);
      
      	subSize.each(function(index) {
          	var id = selectedMeals.data('variant-ids')[index],
                price = selectedMeals.data('variant-prices')[index];
          	
          	$(this).val(id);
            $(this).attr('data-value', price);
          	updateBoldVariants(productId, productHandle, id, price)
        });
      	//unselectedSize.click();
      	selectedSize.prop('checked', false);
      	selectedSize.click();
  	}
  
  	function countSize() {
      	initialPrice = $(this).attr('data-value');
      
     	updateCart();
    }
  
  	function countPickup() {
      	point = $(this).val().toLowerCase();
      	
      	if (point.indexOf('home/office ') > -1 || point.indexOf('evening delivery') > -1) {
      		delivery = deliveryPrice;
          	subDay.filter(':checked').trigger('change');
          	subDeliveryLabel.show();
          	subPickupLabel.hide();
        }
      	else {
        	delivery = 0;  
          	subDeliveryLabel.hide();
          	
          	if (point) 
           		subPickupLabel.show();	
          	else 
            	subPickupLabel.hide();
        }
      
     	updateCart();
    }
  
  	function countDay() {
   		updateCart();
  	}
  
  	function countFrequency() {
      	var weeksCount = $(this).val()*1
        	discountper = $(this).attr('data-discount');
      
    	discount = discountper / 100;
      	weeks = weeksCount,
      	groupid = $(this).attr('data-groupid');
    	
      	prodQuantity.val(weeks);
      	subDiscountInvoice.val(discountper + '%');
      	$('.bold-ro__group-id').val(groupid);
      	$('.bold-ro__frequency-num').val(weeksCount);
      
      	updateCart();
  	}
  
  	function enableSubscribeBtn() {
      var pickupSelected = subPickup.find('option:selected').index() > 0,
          daySelected =  subDay.filter(':checked').length,
          frequencySelected = subFrequency.filter(':checked').length;
      
      if (pickupSelected && daySelected && frequencySelected){
		subNextBtn.prop('disabled', false);
		document.querySelector('.delivery_notification').style.height = '0';
		document.querySelector('.delivery_notification').style.transform = 'scale(0)';
	  }else{
		subNextBtn.prop('disabled', true);
		document.querySelector('.delivery_notification').style.height = '60px';
		document.querySelector('.delivery_notification').style.transform = 'scale(1)';
	  }
    }
  
  	function subscribe() {
      	$('.fmv2-subscription-bold-btn button').click();
  	}
  
  	function assignVars(vars) {
      	quantity = vars.subscribtionQuantity*1;
    	initialPrice = vars.subscribtionInitialPrice*1;
        deliveryPrice = vars.subscribtionDelivery*1;
  	}
  	
  	function init() {
  		subscribeBtn .click(selectProduct);
      	subMeals.change(countMeals);
      	subSize.change(countSize);
      	subPickup.change(countPickup);
      	subDay.change(countDay),
      	subFrequency.change(countFrequency);
      	subNextBtn.click(subscribe)
      
        //if (subCart.length) {
        	//$('.page-container').addClass('weekly-menu');
        //}
      
      	/*setTimeout(function() {
        	$('.bold-ro__group-id').val('170115');
        }, 2000);*/
    }
  
  	return {
      init: init,
      assignVars: assignVars
    }
})();


fmv2.variantRadio = (function() {
	var variantRadio = $('.fmv2-variant-radio input');
  
  	function selectVariant() {
      	var variant = $(this).parent();
      	
      	variant.addClass('active').siblings().removeClass('active');  
    }
  
  	function init() {
    	variantRadio.change(selectVariant);
  	}
  
  	return {
    	init: init  
  	}
})();

function fmV2ProductReviews(original, custom) {
	var ti,
    	stars = custom.find('.fmv2-product-stars'),
        starsCaption = custom.find('p'),
        title = custom.find('h2'),
        writeReview = custom.find('.fmv2-write-review'),
        reviews = custom.find('.fmv2-product-reviews'),
        originalStartSelector = '.spr-summary-starrating',
        originalStarCaptionSelector = '.spr-summary-caption',
        originalTitleSelector = '.spr-header-title',
  		originalReviews = '.spr-reviews',
        originalReviewsTitle = '.spr-review-header-title',
        originalReviewsFooter = '.spr-review-footer',
        originalReviewBtn = '.spr-summary-actions-newreview',
        emptyStarsHtml = '<i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i><i class="spr-icon spr-icon-star-empty"></i>',
  		form,
        formStars,
        formTitle,
        formBtn;
        
        
		ti = setInterval(function() {
    		
        	if (original.find('.spr-container').length && original.find('.new-review-form').length) {
             	clearInterval(ti);
              
              	form = original.find('.new-review-form');
              	formStars = form.find('.spr-form-review-rating');
              	formBtn = form.find('.spr-form-actions input');
              	
              	if (!$(originalStartSelector).html()) 
              		stars.html(emptyStarsHtml)
                else 
           			stars.html($(originalStartSelector).html());
              
              	title.text($(originalTitleSelector).text());
              	writeReview.append($(originalReviewBtn)).find('a').addClass('btn alt');
              	reviews.append($(originalReviews));
              	reviews.find(originalReviews).addClass('fmv2-slider');
              	reviews.find('p').attr('class', '');
              	reviews.find(originalReviewsFooter).find('a').attr('class', '');
              	              
              	if ($(originalStarCaptionSelector).find('span').length) {
                	starsCaption.text($(originalStarCaptionSelector).find('span').text());
              	}
                else{
               		starsCaption.text($(originalStarCaptionSelector).text());
                }
              
              	$(originalReviewsTitle).each(function() {
              		var container = $(this).parent(),
                        date = container.find('.spr-review-header-byline');
                  
                  	date.attr('class','').addClass('article__date').html('<time>' + date.text() + '</time>');
                    $(this).attr('class','');
                  	date.after($(this));
              	});
              
              	$(originalReviewBtn).on('click', function() {
					$(window).scrollTop(form.offset().top);              
              	});
              
              	formTitle = form.find('h3').text();
              	form.find('h3').replaceWith('<h4>' + formTitle + '</h4>').after(formStars);
              	form.find('h4').after(formStars);
              	form.parent().addClass('fmv2-comment-form');
              	form.find('a.spr-icon-star').text('');
              	form.find('label').removeClass('spr-form-label');
              	formBtn.attr('class', '').addClass('btn');
              	
              	form.find('input:not([type=submit]):not([type=hidden])').each(function() {
                  	$(this).removeAttr('placeholder')
                	$(this).parent().addClass('fmv2-form-row');
              	});
              	form.find('textarea').each(function() {
                	$(this).removeAttr('placeholder');
                  	$(this).parents('.spr-form-review-body').addClass('fmv2-form-row');
                  
                  	
                });
              
              	if (reviews.find('.spr-review').length > 1)
              		theme.ReviewsSlider();
              	
              	custom.addClass('loaded');
            }
      }, 200);
}

fmv2.formElements = (function() {
	var formRowSelector = '.fmv2-form-row',
    	select = $('.fmv2-select'),
    	inputElements = $('.fmv2-form-row input, .fmv2-form-row textarea');
	 
  	function selectAction() {
   		var val = $(this).find('option:selected').text(); 
      
      	$(this).find('span').text(val);  
    }
  
  	function animateLabel(e) {
    	if (e.type == 'focusin') {
 			$(this).closest(formRowSelector).find('label').addClass('active');
      	}
      	else {
        	if (!$(this).val()) 
            	$(this).closest(formRowSelector).find('label').removeClass('active');
      	}
  	}
 
  	function init() {
    	select.change(selectAction);
      	$(document).on('focus blur', inputElements.selector, animateLabel);
      
     	inputElements.each(function() {
          	var label = $(this).closest(formRowSelector).find('label');
          
          	if ($(this).val().length && label.length)
          		label.addClass('active');
  		});

  		setTimeout(function() {
			select.trigger('change');
    	}, 500); 	
  	}
  
  	return {
    	init: init
   	}
})();

fmv2.productFilters = (function() {
	var href= window.location.href,
      	weekMenuQuery = '?page=cwm',
        searchQuery = '?page=search-',
        filters = $('.fmv2-our-meals-filters'),
        filtersBtn = filters.find('a'),
        searchInput = $('#fmv2-search-input'),
        searchList = $('.fmv2-our-meals-search ul'),
        searchBtn = $('.fmv2-search-btn'),
        searchNoResult = $('.fmv2-search-noresult');
  
  	
  	function cleanUrl() {
      	var url = href.split('?')[0];
      
      	url = url.split('#')[0];
      
    	return url;
  	}
  
  
  	function filtersAction(event) {
   		var btn = $(this);
      	
      	event.preventDefault();
      
      	if (btn.hasClass('active')) return;
            
      	btn.parent().parent().find('a').toggleClass('active');
      
  		if (btn.parent().index() == 1 && href.indexOf(weekMenuQuery) < 0)
          	window.location.href = cleanUrl() + weekMenuQuery;
      	else
          	window.location.href = cleanUrl() + '?page=1';
    }
  
  
  	function closeSearchList() {
  		searchList.hide().find('li').remove();
    }
  
  
  	function doSearch() {
      	var searchUrl = searchQuery + encodeURI(searchInput.val());
  		
      	window.location.href = cleanUrl() + searchUrl;	
  	}
  
  
  	function serachListControl(e, input) {
    	var key = e.keyCode || e.which,
            active = searchList.find('li.active');
      
      	if (searchList.is(':visible')) {
          	if (key == 38) {
          		e.preventDefault();
              	active.removeClass('active');
              
           		if (active.is(':first-child')) 	
              		searchList.find('li:last').addClass('active');
              	else 
                	active.prev().addClass('active');
          	}
              
          	if (key == 40) {
          		e.preventDefault();
              	active.removeClass('active');
             	 
              	if (active.is(':last-child')) 	
              		searchList.find('li:first').addClass('active');
              	else 
                	active.next().addClass('active');
          	}
          
          	if (key == 13) {
            	searchInput.val(active.text());
  				closeSearchList();		  
            }
      	}
      	else {
       		if (key == 13 && searchInput.val().length > 2) {
            	doSearch();	  
            }  
        }
  	}
  
  	
  	function search(e) {
   		var input = $(this),
            key = e.keyCode || e.which;
      
      	if (key != 38 && key != 40 && key != 13) {
            setTimeout(function() {
                var val = input.val().toLowerCase();

                closeSearchList();

                if (val.length > 2) {
                    for (var i=0; i<ourProductsArray.length; i++) { 
                        if (ourProductsArray[i].indexOf(val) >= 0) {
                            var title = ourProductsArray[i],
                                valStrong = '<strong>' + val + '</strong>',
                                titleStrong = title.replace(val, valStrong);

                            searchList.show().append('<li>' + titleStrong + '</li>');
                            searchList.find('li:first-child').addClass('active');
                        }  
                    }
                  
                  	searchBtn.prop('disabled', false);
                }
              	else {
              		searchBtn.prop('disabled', true);
                }
            }, 10);
        }
      
      	serachListControl(e, input);
  	}
  
  	
  	function blurSearchInput() {
    	setTimeout(function() {
    		closeSearchList();
      	}, 700);
  	}
  
  
  	function selectSearchResult() {
    	searchInput.val($(this).text());
  		closeSearchList();
  	}


 	function init() {
    	filtersBtn.click(filtersAction);
      	searchInput.keydown(search);
      	searchInput.blur(blurSearchInput);
		searchBtn.click(doSearch);
      	$(document).on('click', '.fmv2-our-meals-search li', selectSearchResult);
      	
      	if (href.indexOf(weekMenuQuery) >= 0) 
      		filtersBtn.toggleClass('active');  
          	 
          
      	if (href.indexOf(searchQuery) > 0 ) {
          	filtersBtn.removeClass('active');
        	searchInput.val(decodeURI(href.split(searchQuery)[1].split('#')[0]))
      	}
      
      	if (href.indexOf('?page=') >= 0)
          	 window.location.hash = 'our-meals-filters';
      
      	if (!$('#Collection .grid li').length)
        	searchNoResult.show();
  	}
  
  
  	return {
      	init: init
  	}
})();


fmv2.init = function() {
	var ti,
        gridProductId = '#',
        href = window.location.href,
    	mapWidget = $('.fmv2-map-widget'),
        instagramWrap = $('.fmv2-instagram-items-wrap'),
        reviewsOriginal = $('#shopify-product-reviews'),
        reviewsCustom = $('.fmv2-product-review');
        
        
  	if (mapWidget.length) 
    	mapWidget.parents('.shopify-section').addClass('fmv2-map-section');
  
  	
  	ti = setInterval(function() {
    	var instagramTemplate = $('.fmv2-instagram-item-template');
    
    	if(!instagramTemplate.length) {
      		clearInterval(ti);
          	instagramWrap.addClass('loaded');
    		theme.InstagramSlider();
    	}
  	}, 500);
  
    $('.fmv2-tooltip-btn').click(function(e) { 
      	e.preventDefault();
  		$(this).next().toggle();
   
      	$(this).find('.fa').toggleClass('fa-times-circle').toggleClass('fa-question-circle');
  	});
  
    $('#fmv2-bottom-summary .summary-expand').click(function(e) {
		e.preventDefault();
      	$(this).find('.fa').toggleClass('fa-chevron-down').toggleClass('fa-chevron-up');
      	$('.cart-summary-text-container').toggle();
    })
    
  	if (reviewsOriginal.length && reviewsCustom.length) {
    	fmV2ProductReviews(reviewsOriginal, reviewsCustom);
  	}
  
  	if (href.indexOf('#') > 0) {
    	gridProductId = gridProductId + href.split('#')[1];
      	
      	if ($(gridProductId).length)
        	$(gridProductId).addClass('selected');
  	}
  
  	fmv2.stickyHeader.init();
  	fmv2.productFilters.init();
  	fmv2.formElements.init();
  	fmv2.subscribtion.init();
  	fmv2.variantRadio.init();
}

$(document).on('click', '.mfv2-map-search-button', function(e) {
	var panel = $(this).parent().find('.stockist-side-panel'),
        btn = $(this);
  
  	e.preventDefault();
    
  	panel.toggleClass('expanded');
  
  	if (panel.hasClass('expanded')) 
        btn.text('hide search');
    else
      	btn.text('search');
});

function lightbox(target) {
	target.classList.add('show');

	let lightboxClose = target.querySelector('.fmv2-lightbox-close');

	lightboxClose.addEventListener('click', () => {
		target.classList.remove('show');
	});
}


if(window.location.href.includes('collections/fuelme-meals')){
	document.addEventListener('click', function (event) {
		
		if (event.target.closest('.quickviewlink_image')) {
			
			let targetWrapItem = event.target.parentNode.parentNode.offsetParent.querySelector('.lightbox');
			lightbox(targetWrapItem);
		}

		if (event.target.closest('.quickviewlink_title')) {
			
			let targetWrapItem = event.target.parentNode.querySelector('.lightbox');
			lightbox(targetWrapItem);
		}
	})

}else{
	let arrItemSlider = document.querySelectorAll('[data-image-with-placeholder]'),
	arrlightboxPopup = document.querySelectorAll('[lightbox-popup]');

	arrItemSlider.forEach((item) => {
		item.addEventListener('click', (event)=>{
			let target = event.target;
			let targetAttr = target.getAttribute('id');
			
			arrlightboxPopup.forEach((itemlightbox) => {
				let targetAttrlightbox = itemlightbox.getAttribute('id');
				
				if(targetAttr == targetAttrlightbox){
					let targetCollectionName = target.getAttribute('collection-name');
					let targetlightboxCollectionName = itemlightbox.getAttribute('collection-name');
					if(targetCollectionName == targetlightboxCollectionName){
						lightbox(itemlightbox);
					}
					
				}
			})
			
		})
	})

}

$(document).ready(fmv2.init);